(function () {
  if (window.__mcColcardsNav) return;
  window.__mcColcardsNav = true;
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.mc-colcards__navbtn');
      if (!btn) return;
      var root = btn.closest('.mc-colcards');
      var track = root && root.querySelector('[data-track]');
      if (!track) return;
      var card = track.querySelector('.mc-colcards__card');
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      var stepW = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      var dir = btn.hasAttribute('data-prev') ? -1 : 1;
      track.scrollBy({ left: dir * stepW, behavior: 'smooth' });
    },
    false,
  );
})();
